import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=cbec5eec"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"
import style0 from "./Landing.vue?vue&type=style&index=0&id=cbec5eec&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbec5eec')) {
      api.createRecord('cbec5eec', component.options)
    } else {
      api.reload('cbec5eec', component.options)
    }
    module.hot.accept("./Landing.vue?vue&type=template&id=cbec5eec", function () {
      api.rerender('cbec5eec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Academy/Landing.vue"
export default component.exports